<script>

    import { toast } from 'bulma-toast'
    import { errorStore, errorsStore, modalStore } from '../stores'

    import ErrorsService from '../$services/errors.service'
    import DateMethod from '../$methods/date.method'

    import Spinner from '../$components/spinner.svelte'
    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'

    let loading = false

    $: pickup = $errorStore.body && $errorStore.body.pickup
    $: delivery = $errorStore.body && $errorStore.body.delivery

    async function deleteError() {

        loading = true
        const resp = await ErrorsService.deleteError($errorStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        errorsStore.remove($errorStore._id)
        toast({message: 'Error eliminado', type: 'is-success'})
        modalStore.close()
    }

</script>

<Spinner {loading} />

{#if !loading}
    <DetailsCard
        title={$errorStore.supportCode ? String($errorStore.supportCode) : 'Error'}
        meta={DateMethod.dateTimeLarge($errorStore.created)}
    >
        <DetailsFields>
            {#if $errorStore.user && $errorStore.user.name}
                <DetailsField label="Usuario">
                    <div>
                        <div>{ $errorStore.user.name }</div>
                        <div><b>{ $errorStore.user.email }</b></div>
                    </div>
                </DetailsField>
            {/if}
            <DetailsField label="Partner" value={$errorStore.partner || $errorStore.provider || ''} />
            <DetailsField label="Proveedor" value={$errorStore.provider} />
            <DetailsField label="Servicio" value={$errorStore.service} />
            {#if $errorStore.message}
                <DetailsField label="Mensaje" value={$errorStore.message} />
            {/if}
            {#if pickup}
                <DetailsField label="Origen">
                    <div class="is-size-7">
                        <div><b>{ pickup.contact }</b></div>
                        {#if pickup.corporate}<div>{ pickup.corporate }</div>{/if}
                        {#if pickup.rfc}<div>{ pickup.rfc }</div>{/if}
                        {#if pickup.phone}<div>{ pickup.phone }</div>{/if}
                        {#if pickup.email}<div>{ pickup.email }</div>{/if}
                        <div>
                            { [pickup.city, pickup.state].filter(Boolean).join(', ') }
                        </div>
                        <div>
                            { [pickup.colony, pickup.municipality].filter(Boolean).join(', ') }
                        </div>
                        <div>
                            { [pickup.street, pickup.number, pickup.apartment].filter(Boolean).join(' ') }
                        </div>
                        {#if pickup.references}<div>{ pickup.references }</div>{/if}
                    </div>
                </DetailsField>
            {/if}
            {#if delivery}
                <DetailsField label="Destino">
                    <div class="is-size-7">
                        <div><b>{ delivery.contact }</b></div>
                        {#if delivery.corporate}<div>{ delivery.corporate }</div>{/if}
                        {#if delivery.rfc}<div>{ delivery.rfc }</div>{/if}
                        {#if delivery.phone}<div>{ delivery.phone }</div>{/if}
                        {#if delivery.email}<div>{ delivery.email }</div>{/if}
                        <div>
                            { [delivery.city, delivery.state].filter(Boolean).join(', ') }
                        </div>
                        <div>
                            { [delivery.colony, delivery.municipality].filter(Boolean).join(', ') }
                        </div>
                        <div>
                            { [delivery.street, delivery.number, delivery.apartment].filter(Boolean).join(' ') }
                        </div>
                        {#if delivery.references}<div>{ delivery.references }</div>{/if}
                    </div>
                </DetailsField>
            {/if}
            {#if $errorStore.stack}
                <DetailsField label="Stack" full>
                    <pre class="is-size-7 pre-json">{ $errorStore.stack }</pre>
                </DetailsField>
            {/if}
            {#if $errorStore.raw}
                <DetailsField label="Raw" full>
                    <pre class="is-size-7 pre-json">{ JSON.stringify($errorStore.raw, null, 2) }</pre>
                </DetailsField>
            {/if}
            {#if $errorStore.body}
                <DetailsField label="Body" full>
                    <pre class="is-size-7 pre-json">{ JSON.stringify($errorStore.body, null, 2) }</pre>
                </DetailsField>
            {/if}
            {#if $errorStore.quotation}
                <DetailsField label="Cotización" full>
                    <pre class="is-size-7 pre-json">{ JSON.stringify($errorStore.quotation, null, 2) }</pre>
                </DetailsField>
            {/if}
            <DetailsField label="Función" value={$errorStore.function} mono />
        </DetailsFields>

        <div slot="footer">
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <ButtonDelete on:confirm={deleteError} {loading} />
            </div>
        </div>
    </DetailsCard>
{/if}

